<template>
  <div class="form-group" :data-testid="'field-' + field.key"
       :class="[ to.inputType, {'formly-has-value': model[field.key], 'formly-has-focus': form[field.key].$active, 'has-error': hasError}]">
    <label v-if="to.label" v-text="$t('formly.fields.' + to.label)"></label>
    <multiselect v-if="isString"
                 @search-change="getOptions"
                 :multiple="field.multiple ? field.multiple : false"
                 :taggable="field.taggable" @tag="addTagString"
                 :custom-label="to.customLabel ? to.customLabel : customLabel"
                 :placeholder="$tc('select.option', field.multiple ? 2 : 1)"
                 :close-on-select="!field.multiple"
                 v-model="model[field.key]"
                 :internal-search="!field.optionsApi"
                 :options="options">
      <template v-if="field.multiple" slot="option" slot-scope="{ option }">
        <div class="multiselect-checkbox-option">
          <input type="checkbox" :checked="isOptionSelected(option)" tabindex="-1" @click.prevent />
          <span>{{ to.customLabel ? to.customLabel(option) : customLabel(option) }}</span>
        </div>
      </template>
    </multiselect>
    <multiselect v-else
                 :track-by="field.trackBy || 'uuid'"
                 @search-change="getOptions"
                 :multiple="field.multiple ? field.multiple : false"
                 :taggable="field.taggable" @tag="addTagObject"
                 :custom-label="to.customLabel ? to.customLabel : customLabel"
                 :close-on-select="!field.multiple"
                 :placeholder="$tc('select.option', field.multiple ? 2 : 1)"
                 v-model="model[field.key]"
                 :disabled="field.disabled"
                 :internal-search="!field.optionsApi"
                 :options="options">
      <template v-if="field.multiple" slot="option" slot-scope="{ option }">
        <div class="multiselect-checkbox-option">
          <input type="checkbox" :checked="isOptionSelected(option)" tabindex="-1" @click.prevent />
          <span>{{ to.customLabel ? to.customLabel(option) : customLabel(option) }}</span>
        </div>
      </template>
    </multiselect>

    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import ApiService from '@/services/api.service'
import baseField from 'vue-formly-bootstrap/src/fields/baseField'
import Multiselect from 'vue-multiselect'
import ErrorDisplay from '../formly-bootstrap/components/errorDisplay'
import VueI18n from '@/i18n'
import { debounce } from '@/lib/debounce'
import TagService from '@/services/tag.service'

export default {
  mixins: [baseField],
  data () {
    return {
      options: []
    }
  },
  components: {
    Multiselect,
    ErrorDisplay
  },
  mounted () {
    if (this.field.options) {
      this.options = this.field.options
    } else {
      this.getOptionsInit()
    }
  },
  watch: {
    'field.options': 'updateOptions'
  },
  methods: {
    attachTag (name) {
      return TagService.attach({
        name
      })
    },
    addTagObject (newTag) {
      const tag = {
        name: newTag,
        uuid: newTag
      }

      this.options.push(tag)

      this.model[this.field.key].push(tag)
    },
    addTagString (newTag) {
      const tagString = this.field.storeTags ? newTag.toLowerCase() : newTag

      if (this.field.storeTags) {
        this.attachTag(tagString)
      }
      this.options.push(tagString)

      this.model[this.field.key].push(tagString)
    },
    customLabel (o) {
      if (o && o.isTag) {
        return o.label
      }

      const translationObject = this.to.translationObject ?? 'select.options'

      if (this.isString) {
        if (this.to.translated) {
          return VueI18n.t(translationObject + '.' + o)
        }

        return o
      } else {
        if (this.to.translated) {
          return `${o.name ? VueI18n.t(translationObject + '.' + o) : ''}`
        }

        return `${o.name ? o.name : ''}`
      }
    },
    updateOptions () {
      this.options = this.field.options
    },
    getOptionsInit () {
      const params = this.getParams()

      if (this.field.optionsApi && !this.field.options) {
        ApiService.get(`api/v1/admin/search/${this.field.optionsApi}`, { params })
          .then((response) => {
            this.options = response.data
          })
      } else {
        this.options = this.field.options ?? []
      }
    },
    getParams (q = null) {
      const params = {
        search: q || ''
      }

      if (!this.field.additionalQueryParams) {
        return params
      }

      Object.keys(this.field.additionalQueryParams).forEach((key) => {
        params[key] = this.$store.state[this.field.additionalQueryParams[key]]?.uuid
      })

      return params
    },
    isOptionSelected (option) {
      const value = this.model[this.field.key]
      if (!value || !Array.isArray(value)) return false
      if (this.isString) {
        return value.includes(option)
      }
      const trackBy = this.field.trackBy || 'uuid'
      return value.some(item => item[trackBy] === option[trackBy])
    },
    getOptions: debounce(function (q) {
      const params = this.getParams(q)

      if (this.field.optionsApi && !this.field.options) {
        ApiService.get(`api/v1/admin/search/${this.field.optionsApi}`, { params })
          .then((response) => {
            this.options = response.data
          })
      }
    }, 200)
  },
  computed: {
    isString () {
      return this.field.isString
    }
  }
}
</script>

<style scoped>
.multiselect-checkbox-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.multiselect-checkbox-option input[type="checkbox"] {
  flex-shrink: 0;
  pointer-events: none;
  cursor: pointer;
  width: 15px;
  height: 15px;
  accent-color: currentColor;
}
</style>
